!(function (e) {
    var t = {};
    function i(n) {
        if (t[n]) return t[n].exports;
        var s = (t[n] = { i: n, l: !1, exports: {} });
        return e[n].call(s.exports, s, s.exports, i), (s.l = !0), s.exports;
    }
    (i.m = e),
        (i.c = t),
        (i.d = function (e, t, n) {
            i.o(e, t) || Object.defineProperty(e, t, { enumerable: !0, get: n });
        }),
        (i.r = function (e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(e, "__esModule", { value: !0 });
        }),
        (i.t = function (e, t) {
            if ((1 & t && (e = i(e)), 8 & t)) return e;
            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
            var n = Object.create(null);
            if ((i.r(n), Object.defineProperty(n, "default", { enumerable: !0, value: e }), 2 & t && "string" != typeof e))
                for (var s in e)
                    i.d(
                        n,
                        s,
                        function (t) {
                            return e[t];
                        }.bind(null, s)
                    );
            return n;
        }),
        (i.n = function (e) {
            var t =
                e && e.__esModule
                    ? function () {
                          return e.default;
                      }
                    : function () {
                          return e;
                      };
            return i.d(t, "a", t), t;
        }),
        (i.o = function (e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }),
        (i.p = ""),
        i((i.s = 4));
})([
    function (e, t, i) {
        "use strict";
        i.d(t, "g", function () {
            return s;
        }),
            i.d(t, "k", function () {
                return r;
            }),
            i.d(t, "j", function () {
                return l;
            }),
            i.d(t, "b", function () {
                return o;
            }),
            i.d(t, "l", function () {
                return a;
            }),
            i.d(t, "a", function () {
                return c;
            }),
            i.d(t, "d", function () {
                return d;
            }),
            i.d(t, "h", function () {
                return u;
            }),
            i.d(t, "f", function () {
                return h;
            }),
            i.d(t, "c", function () {
                return m;
            }),
            i.d(t, "e", function () {
                return f;
            }),
            i.d(t, "i", function () {
                return p;
            });
        var n = document.querySelector("[data-site-container]");
        function s() {
            (n.style.overflowY = "hidden"), (n.style.height = "100dvh");
        }
        function r() {
            n.style.removeProperty("overflow"), (n.style.height = "auto");
        }
        function l(e, t, i) {
            let n = "";
            if (i && "" !== i) {
                let e = new Date();
                e.setTime(e.getTime() + 24 * i * 60 * 60 * 1e3), (n = "; expires=" + e.toUTCString());
            } else n = '; expires=""';
            document.cookie = `${e}=${t}${n}; path=/`;
        }
        function o(e) {
            let t = e + "=",
                i = document.cookie.split(";");
            for (let e = 0; e < i.length; e++) {
                let n = i[e];
                for (; " " == n.charAt(0); ) n = n.substring(1);
                if (-1 != n.indexOf(t)) return n.substring(t.length, n.length);
            }
            return null;
        }
        function a(e) {
            const t = e.includes("&") ? e.split("&")[0] : e,
                i = document.querySelector('[type="application/ld+json"]'),
                n = i.innerHTML;
            let [s, r] = n.split('"@id": "');
            (r = r.split(r.split('"')[0])[1]), console.log(`${s}"@id": "${t}${r}`), (i.innerHTML = `${s}"@id": "${t}${r}`), (document.querySelector('[rel="canonical"]').href = theme.url + t);
        }
        const c = (e, t) => {
            let i;
            return function (...n) {
                i && clearTimeout(i),
                    (i = setTimeout(() => {
                        e(...n);
                    }, t));
            };
        };
        async function d(e) {
            const t = await fetch(e, { method: "get", headers: { Accept: "application/json, text/plain, */*", "Content-Type": "application/json" } });
            return await t.json();
        }
        async function u(e, t, i = {}) {
            const n = await fetch(e, { method: "POST", headers: { "Content-Type": "application/json", ...i }, body: JSON.stringify(t) });
            if (!n.ok) throw new Error("HTTP error! Status: " + n.status);
            return await n.json();
        }
        async function h(e) {
            const t = e.handle ? "/products/" + e.handle : e.mappings.core.url,
                i = e.params && e.params.lazyload ? "" : "&lazyload=false",
                n = e.params && e.params.isSlide ? "&slide=true" : "",
                s = e.params && "false" == e.params.showWishlist ? "&wishlist=false" : "",
                r = e.params && "false" == e.params.showStrips ? "&featureStrips=false" : "",
                l = e.params && "false" == e.params.showReviews ? "&reviews=false" : "",
                o = e.params && "false" == e.params.showRoundels ? "&roundels=false" : "",
                a = e.params && "true" == e.params.altImage ? "&alternatePicture=true" : "",
                c = e.params && void 0 !== e.params.index ? "&index=" + e.params.index : "",
                d = `${t}?sections=product-list-item${i}${n}${l}${o}${a}${s}${r}${e.intellisuggestData ? "&intellisuggestData=" + e.intellisuggestData : ""}${
                    e.intellisuggestSignature ? "&intellisuggestSignature=" + e.intellisuggestSignature : ""
                }${c}`;
            return await fetch(d, { method: "get", headers: { Accept: "application/json, text/plain, */*", "Content-Type": "application/json" } });
        }
        async function m(e, t) {
            const i = e.handle ? "/products/" + e.handle : e.mappings.core.url,
                n = await (async function (e) {
                    try {
                        let t = await fetch(e);
                        if (!t.ok) throw new Error(`HTTP error for endpoint ${e} - Status: ${t.status}`);
                        return await t.json();
                    } catch (e) {
                        return console.error("Error fetching data:", e), {};
                    }
                })(i + "?view=gaData");
            return (function (e, t = {}, i) {
                const n = e.mappings ? { id: e.id, ...e.mappings.core } : e,
                    s = { index: i, discount: n.msrp - n.price, item_brand: n.brand, price: n.price, quantity: 1 };
                return (
                    n.product_type_unigram && (s.item_variant = n.product_type_unigram),
                    t.item_id || (s.item_id = n.id),
                    t.item_name || (s.item_name = n.name),
                    e.mappings ? (s.item_category4 = "Rec: " + e.params.placementTag) : theme.relativeItemCategory && (s.item_category4 = theme.relativeItemCategory),
                    { ...s, ...t }
                );
            })(e, (await n).product, t);
        }
        async function f(e) {
            const t = `/products/${e.handle}?sections=product-list-item&lazyload=false`;
            return await fetch(t, { method: "get", headers: { Accept: "application/json, text/plain, */*", "Content-Type": "application/json" } });
        }
        function p(e, t, i = theme.collectionName, n = theme.collectionTitle) {
            console.log(t), console.log({ item_list_id: i || "", item_list_name: n || theme.relativeItemCategory, items: e });
        }
    },
    function (e, t, i) {
        "use strict";
        let n;
        i.r(t),
            i.d(t, "v1", function () {
                return p;
            }),
            i.d(t, "v3", function () {
                return k;
            }),
            i.d(t, "v4", function () {
                return E;
            }),
            i.d(t, "v5", function () {
                return $;
            }),
            i.d(t, "NIL", function () {
                return x;
            }),
            i.d(t, "version", function () {
                return M;
            }),
            i.d(t, "validate", function () {
                return o;
            }),
            i.d(t, "stringify", function () {
                return d;
            }),
            i.d(t, "parse", function () {
                return g;
            });
        const s = new Uint8Array(16);
        function r() {
            if (!n && ((n = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)), !n))
                throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
            return n(s);
        }
        var l = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i,
            o = function (e) {
                return "string" == typeof e && l.test(e);
            };
        const a = [];
        for (let e = 0; e < 256; ++e) a.push((e + 256).toString(16).slice(1));
        function c(e, t = 0) {
            return (
                a[e[t + 0]] +
                a[e[t + 1]] +
                a[e[t + 2]] +
                a[e[t + 3]] +
                "-" +
                a[e[t + 4]] +
                a[e[t + 5]] +
                "-" +
                a[e[t + 6]] +
                a[e[t + 7]] +
                "-" +
                a[e[t + 8]] +
                a[e[t + 9]] +
                "-" +
                a[e[t + 10]] +
                a[e[t + 11]] +
                a[e[t + 12]] +
                a[e[t + 13]] +
                a[e[t + 14]] +
                a[e[t + 15]]
            );
        }
        var d = function (e, t = 0) {
            const i = c(e, t);
            if (!o(i)) throw TypeError("Stringified UUID is invalid");
            return i;
        };
        let u,
            h,
            m = 0,
            f = 0;
        var p = function (e, t, i) {
                let n = (t && i) || 0;
                const s = t || new Array(16);
                let l = (e = e || {}).node || u,
                    o = void 0 !== e.clockseq ? e.clockseq : h;
                if (null == l || null == o) {
                    const t = e.random || (e.rng || r)();
                    null == l && (l = u = [1 | t[0], t[1], t[2], t[3], t[4], t[5]]), null == o && (o = h = 16383 & ((t[6] << 8) | t[7]));
                }
                let a = void 0 !== e.msecs ? e.msecs : Date.now(),
                    d = void 0 !== e.nsecs ? e.nsecs : f + 1;
                const p = a - m + (d - f) / 1e4;
                if ((p < 0 && void 0 === e.clockseq && (o = (o + 1) & 16383), (p < 0 || a > m) && void 0 === e.nsecs && (d = 0), d >= 1e4)) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
                (m = a), (f = d), (h = o), (a += 122192928e5);
                const g = (1e4 * (268435455 & a) + d) % 4294967296;
                (s[n++] = (g >>> 24) & 255), (s[n++] = (g >>> 16) & 255), (s[n++] = (g >>> 8) & 255), (s[n++] = 255 & g);
                const y = ((a / 4294967296) * 1e4) & 268435455;
                (s[n++] = (y >>> 8) & 255), (s[n++] = 255 & y), (s[n++] = ((y >>> 24) & 15) | 16), (s[n++] = (y >>> 16) & 255), (s[n++] = (o >>> 8) | 128), (s[n++] = 255 & o);
                for (let e = 0; e < 6; ++e) s[n + e] = l[e];
                return t || c(s);
            },
            g = function (e) {
                if (!o(e)) throw TypeError("Invalid UUID");
                let t;
                const i = new Uint8Array(16);
                return (
                    (i[0] = (t = parseInt(e.slice(0, 8), 16)) >>> 24),
                    (i[1] = (t >>> 16) & 255),
                    (i[2] = (t >>> 8) & 255),
                    (i[3] = 255 & t),
                    (i[4] = (t = parseInt(e.slice(9, 13), 16)) >>> 8),
                    (i[5] = 255 & t),
                    (i[6] = (t = parseInt(e.slice(14, 18), 16)) >>> 8),
                    (i[7] = 255 & t),
                    (i[8] = (t = parseInt(e.slice(19, 23), 16)) >>> 8),
                    (i[9] = 255 & t),
                    (i[10] = ((t = parseInt(e.slice(24, 36), 16)) / 1099511627776) & 255),
                    (i[11] = (t / 4294967296) & 255),
                    (i[12] = (t >>> 24) & 255),
                    (i[13] = (t >>> 16) & 255),
                    (i[14] = (t >>> 8) & 255),
                    (i[15] = 255 & t),
                    i
                );
            };
        function y(e, t, i) {
            function n(e, n, s, r) {
                var l;
                if (
                    ("string" == typeof e &&
                        (e = (function (e) {
                            e = unescape(encodeURIComponent(e));
                            const t = [];
                            for (let i = 0; i < e.length; ++i) t.push(e.charCodeAt(i));
                            return t;
                        })(e)),
                    "string" == typeof n && (n = g(n)),
                    16 !== (null === (l = n) || void 0 === l ? void 0 : l.length))
                )
                    throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
                let o = new Uint8Array(16 + e.length);
                if ((o.set(n), o.set(e, n.length), (o = i(o)), (o[6] = (15 & o[6]) | t), (o[8] = (63 & o[8]) | 128), s)) {
                    r = r || 0;
                    for (let e = 0; e < 16; ++e) s[r + e] = o[e];
                    return s;
                }
                return c(o);
            }
            try {
                n.name = e;
            } catch (e) {}
            return (n.DNS = "6ba7b810-9dad-11d1-80b4-00c04fd430c8"), (n.URL = "6ba7b811-9dad-11d1-80b4-00c04fd430c8"), n;
        }
        function v(e) {
            return 14 + (((e + 64) >>> 9) << 4) + 1;
        }
        function b(e, t) {
            const i = (65535 & e) + (65535 & t);
            return (((e >> 16) + (t >> 16) + (i >> 16)) << 16) | (65535 & i);
        }
        function C(e, t, i, n, s, r) {
            return b(((l = b(b(t, e), b(n, r))) << (o = s)) | (l >>> (32 - o)), i);
            var l, o;
        }
        function w(e, t, i, n, s, r, l) {
            return C((t & i) | (~t & n), e, t, s, r, l);
        }
        function L(e, t, i, n, s, r, l) {
            return C((t & n) | (i & ~n), e, t, s, r, l);
        }
        function A(e, t, i, n, s, r, l) {
            return C(t ^ i ^ n, e, t, s, r, l);
        }
        function S(e, t, i, n, s, r, l) {
            return C(i ^ (t | ~n), e, t, s, r, l);
        }
        var k = y("v3", 48, function (e) {
                if ("string" == typeof e) {
                    const t = unescape(encodeURIComponent(e));
                    e = new Uint8Array(t.length);
                    for (let i = 0; i < t.length; ++i) e[i] = t.charCodeAt(i);
                }
                return (function (e) {
                    const t = [],
                        i = 32 * e.length;
                    for (let n = 0; n < i; n += 8) {
                        const i = (e[n >> 5] >>> n % 32) & 255,
                            s = parseInt("0123456789abcdef".charAt((i >>> 4) & 15) + "0123456789abcdef".charAt(15 & i), 16);
                        t.push(s);
                    }
                    return t;
                })(
                    (function (e, t) {
                        (e[t >> 5] |= 128 << t % 32), (e[v(t) - 1] = t);
                        let i = 1732584193,
                            n = -271733879,
                            s = -1732584194,
                            r = 271733878;
                        for (let t = 0; t < e.length; t += 16) {
                            const l = i,
                                o = n,
                                a = s,
                                c = r;
                            (i = w(i, n, s, r, e[t], 7, -680876936)),
                                (r = w(r, i, n, s, e[t + 1], 12, -389564586)),
                                (s = w(s, r, i, n, e[t + 2], 17, 606105819)),
                                (n = w(n, s, r, i, e[t + 3], 22, -1044525330)),
                                (i = w(i, n, s, r, e[t + 4], 7, -176418897)),
                                (r = w(r, i, n, s, e[t + 5], 12, 1200080426)),
                                (s = w(s, r, i, n, e[t + 6], 17, -1473231341)),
                                (n = w(n, s, r, i, e[t + 7], 22, -45705983)),
                                (i = w(i, n, s, r, e[t + 8], 7, 1770035416)),
                                (r = w(r, i, n, s, e[t + 9], 12, -1958414417)),
                                (s = w(s, r, i, n, e[t + 10], 17, -42063)),
                                (n = w(n, s, r, i, e[t + 11], 22, -1990404162)),
                                (i = w(i, n, s, r, e[t + 12], 7, 1804603682)),
                                (r = w(r, i, n, s, e[t + 13], 12, -40341101)),
                                (s = w(s, r, i, n, e[t + 14], 17, -1502002290)),
                                (n = w(n, s, r, i, e[t + 15], 22, 1236535329)),
                                (i = L(i, n, s, r, e[t + 1], 5, -165796510)),
                                (r = L(r, i, n, s, e[t + 6], 9, -1069501632)),
                                (s = L(s, r, i, n, e[t + 11], 14, 643717713)),
                                (n = L(n, s, r, i, e[t], 20, -373897302)),
                                (i = L(i, n, s, r, e[t + 5], 5, -701558691)),
                                (r = L(r, i, n, s, e[t + 10], 9, 38016083)),
                                (s = L(s, r, i, n, e[t + 15], 14, -660478335)),
                                (n = L(n, s, r, i, e[t + 4], 20, -405537848)),
                                (i = L(i, n, s, r, e[t + 9], 5, 568446438)),
                                (r = L(r, i, n, s, e[t + 14], 9, -1019803690)),
                                (s = L(s, r, i, n, e[t + 3], 14, -187363961)),
                                (n = L(n, s, r, i, e[t + 8], 20, 1163531501)),
                                (i = L(i, n, s, r, e[t + 13], 5, -1444681467)),
                                (r = L(r, i, n, s, e[t + 2], 9, -51403784)),
                                (s = L(s, r, i, n, e[t + 7], 14, 1735328473)),
                                (n = L(n, s, r, i, e[t + 12], 20, -1926607734)),
                                (i = A(i, n, s, r, e[t + 5], 4, -378558)),
                                (r = A(r, i, n, s, e[t + 8], 11, -2022574463)),
                                (s = A(s, r, i, n, e[t + 11], 16, 1839030562)),
                                (n = A(n, s, r, i, e[t + 14], 23, -35309556)),
                                (i = A(i, n, s, r, e[t + 1], 4, -1530992060)),
                                (r = A(r, i, n, s, e[t + 4], 11, 1272893353)),
                                (s = A(s, r, i, n, e[t + 7], 16, -155497632)),
                                (n = A(n, s, r, i, e[t + 10], 23, -1094730640)),
                                (i = A(i, n, s, r, e[t + 13], 4, 681279174)),
                                (r = A(r, i, n, s, e[t], 11, -358537222)),
                                (s = A(s, r, i, n, e[t + 3], 16, -722521979)),
                                (n = A(n, s, r, i, e[t + 6], 23, 76029189)),
                                (i = A(i, n, s, r, e[t + 9], 4, -640364487)),
                                (r = A(r, i, n, s, e[t + 12], 11, -421815835)),
                                (s = A(s, r, i, n, e[t + 15], 16, 530742520)),
                                (n = A(n, s, r, i, e[t + 2], 23, -995338651)),
                                (i = S(i, n, s, r, e[t], 6, -198630844)),
                                (r = S(r, i, n, s, e[t + 7], 10, 1126891415)),
                                (s = S(s, r, i, n, e[t + 14], 15, -1416354905)),
                                (n = S(n, s, r, i, e[t + 5], 21, -57434055)),
                                (i = S(i, n, s, r, e[t + 12], 6, 1700485571)),
                                (r = S(r, i, n, s, e[t + 3], 10, -1894986606)),
                                (s = S(s, r, i, n, e[t + 10], 15, -1051523)),
                                (n = S(n, s, r, i, e[t + 1], 21, -2054922799)),
                                (i = S(i, n, s, r, e[t + 8], 6, 1873313359)),
                                (r = S(r, i, n, s, e[t + 15], 10, -30611744)),
                                (s = S(s, r, i, n, e[t + 6], 15, -1560198380)),
                                (n = S(n, s, r, i, e[t + 13], 21, 1309151649)),
                                (i = S(i, n, s, r, e[t + 4], 6, -145523070)),
                                (r = S(r, i, n, s, e[t + 11], 10, -1120210379)),
                                (s = S(s, r, i, n, e[t + 2], 15, 718787259)),
                                (n = S(n, s, r, i, e[t + 9], 21, -343485551)),
                                (i = b(i, l)),
                                (n = b(n, o)),
                                (s = b(s, a)),
                                (r = b(r, c));
                        }
                        return [i, n, s, r];
                    })(
                        (function (e) {
                            if (0 === e.length) return [];
                            const t = 8 * e.length,
                                i = new Uint32Array(v(t));
                            for (let n = 0; n < t; n += 8) i[n >> 5] |= (255 & e[n / 8]) << n % 32;
                            return i;
                        })(e),
                        8 * e.length
                    )
                );
            }),
            I = { randomUUID: "undefined" != typeof crypto && crypto.randomUUID && crypto.randomUUID.bind(crypto) },
            E = function (e, t, i) {
                if (I.randomUUID && !t && !e) return I.randomUUID();
                const n = (e = e || {}).random || (e.rng || r)();
                if (((n[6] = (15 & n[6]) | 64), (n[8] = (63 & n[8]) | 128), t)) {
                    i = i || 0;
                    for (let e = 0; e < 16; ++e) t[i + e] = n[e];
                    return t;
                }
                return c(n);
            };
        function P(e, t, i, n) {
            switch (e) {
                case 0:
                    return (t & i) ^ (~t & n);
                case 1:
                case 3:
                    return t ^ i ^ n;
                case 2:
                    return (t & i) ^ (t & n) ^ (i & n);
            }
        }
        function T(e, t) {
            return (e << t) | (e >>> (32 - t));
        }
        var $ = y("v5", 80, function (e) {
                const t = [1518500249, 1859775393, 2400959708, 3395469782],
                    i = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
                if ("string" == typeof e) {
                    const t = unescape(encodeURIComponent(e));
                    e = [];
                    for (let i = 0; i < t.length; ++i) e.push(t.charCodeAt(i));
                } else Array.isArray(e) || (e = Array.prototype.slice.call(e));
                e.push(128);
                const n = e.length / 4 + 2,
                    s = Math.ceil(n / 16),
                    r = new Array(s);
                for (let t = 0; t < s; ++t) {
                    const i = new Uint32Array(16);
                    for (let n = 0; n < 16; ++n) i[n] = (e[64 * t + 4 * n] << 24) | (e[64 * t + 4 * n + 1] << 16) | (e[64 * t + 4 * n + 2] << 8) | e[64 * t + 4 * n + 3];
                    r[t] = i;
                }
                (r[s - 1][14] = (8 * (e.length - 1)) / Math.pow(2, 32)), (r[s - 1][14] = Math.floor(r[s - 1][14])), (r[s - 1][15] = (8 * (e.length - 1)) & 4294967295);
                for (let e = 0; e < s; ++e) {
                    const n = new Uint32Array(80);
                    for (let t = 0; t < 16; ++t) n[t] = r[e][t];
                    for (let e = 16; e < 80; ++e) n[e] = T(n[e - 3] ^ n[e - 8] ^ n[e - 14] ^ n[e - 16], 1);
                    let s = i[0],
                        l = i[1],
                        o = i[2],
                        a = i[3],
                        c = i[4];
                    for (let e = 0; e < 80; ++e) {
                        const i = Math.floor(e / 20),
                            r = (T(s, 5) + P(i, l, o, a) + c + t[i] + n[e]) >>> 0;
                        (c = a), (a = o), (o = T(l, 30) >>> 0), (l = s), (s = r);
                    }
                    (i[0] = (i[0] + s) >>> 0), (i[1] = (i[1] + l) >>> 0), (i[2] = (i[2] + o) >>> 0), (i[3] = (i[3] + a) >>> 0), (i[4] = (i[4] + c) >>> 0);
                }
                return [
                    (i[0] >> 24) & 255,
                    (i[0] >> 16) & 255,
                    (i[0] >> 8) & 255,
                    255 & i[0],
                    (i[1] >> 24) & 255,
                    (i[1] >> 16) & 255,
                    (i[1] >> 8) & 255,
                    255 & i[1],
                    (i[2] >> 24) & 255,
                    (i[2] >> 16) & 255,
                    (i[2] >> 8) & 255,
                    255 & i[2],
                    (i[3] >> 24) & 255,
                    (i[3] >> 16) & 255,
                    (i[3] >> 8) & 255,
                    255 & i[3],
                    (i[4] >> 24) & 255,
                    (i[4] >> 16) & 255,
                    (i[4] >> 8) & 255,
                    255 & i[4],
                ];
            }),
            x = "00000000-0000-0000-0000-000000000000",
            M = function (e) {
                if (!o(e)) throw TypeError("Invalid UUID");
                return parseInt(e.slice(14, 15), 16);
            };
    },
    ,
    ,
    function (e, t, i) {
        e.exports = i(5);
    },
    function (e, t, i) {
        "use strict";
        i.r(t);
        var n = i(0);
        const s = i(1),
            r = theme.template,
            l = {
                collectionDescription: `[data-${r}-description]`,
                collectionView: `[data-${r}-view]`,
                collectionSort: `[data-${r}-sort]`,
                collectionProducts: `[data-${r}-products]`,
                collectionPagination: `[data-${r}-pagination]`,
                collectionPaginationLessBtn: `[data-${r}-pagination-less-btn]`,
                collectionPaginationMoreBtn: `[data-${r}-pagination-more-btn]`,
                collectionEmptyBack: `[data-${r}-empty-back]`,
                productItem: ".product-list-item",
                skuAttr: "data-product-sku",
                filtersClear: "[data-clear-filter-link]",
                filtersApply: `[data-${r}-filters-apply]`,
                priceRangeSlider: "[data-price-range-slider]",
                minValueInput: "[data-min-value-input]",
                maxValueInput: "[data-max-value-input]",
                storefrontFiltersForm: "[data-storefront-filter-form]",
                filtersOpen: `[data-${r}-filters-open]`,
                sizesMenu: `[data-${r}-sizes-open]`,
                filtersClose: `[data-${r}-filters-close]`,
                filtersOverlay: "[data-filters-overlay]",
                resultsContainer: "[data-results-container]",
                filters: `[data-${r}-filters]`,
                filtersCategoryToggle: `[data-${r}-filters-category-toggle]`,
                filtersCategoryToggleTemplate: "[data-togglename-filters-category-toggle]",
                filtersCategoryContent: `[data-${r}-filters-category-content]`,
                filtersCategoryContentTemplate: "[data-togglename-filters-category-content]",
                filtersCategoryColumn: ".filters-categories-column",
                filtersContentColumn: ".filter-content-column",
                activeFiltersList: ".active-filters-list",
                filtersLink: "[id^=filter]",
                filtersHeader: "[data-filters-header]",
                clearAllLink: ".clear-all-link",
                collectionPaginationLess: `[data-${r}-pagination-less]`,
                collectionPaginationMore: `[data-${r}-pagination-more]`,
                sortBy: "#sort-by",
                zeroResults: "[data-zero-results]",
                queryInfoAttr: "data-query-info",
                didYouMeanAttr: "data-did-you-mean",
                noResultsAttr: "data-no-results",
                suggestLinkAttr: "data-suggest-link",
                searchInput: "#search-input",
                collectionUtils: "[data-collection-utils]",
                gorgiasChatContainer: "#gorgias-chat-container",
                searchspringRecsContainer: "#ss-recs-container",
                siteContainer: ".site-container",
            },
            o = "is-active",
            a = "is-disabled",
            c = "is-loading",
            d = "is-visible",
            u = "data-size-link",
            h = "has-active-filters",
            m = "is-empty",
            f = "is-scrolled",
            p = `https://${theme.siteId}.a.searchspring.io/api/`,
            g = "search/search.json?siteId=" + theme.siteId,
            y = (theme.siteId, theme.siteId, "template"),
            v = "ss_filter_sizes";
        function b(e, t) {
            return e.replaceAll(y, t.field).replace("Template", t.label).replace("togglename", r);
        }
        const C = {
                onFiltersInit(e) {
                    this.initElements(),
                        this.captureTemplateNodes(),
                        (this.productItemSection = "product-list-item"),
                        (this.template = r),
                        (this.state = {}),
                        (this.state.isFetching = !1),
                        (this.state.lastClicked = null),
                        (this.state.activeFilters = []),
                        (-1 === window.location.href.indexOf("?") ? [] : window.location.href.split("?")[1].split("&")).forEach((e) => {
                            if (-1 !== e.indexOf("filter.")) {
                                const t = decodeURI(e);
                                this.state.activeFilters = [...this.state.activeFilters, t];
                            } else -1 !== e.indexOf("page=") ? (this.state.pageNum = e.split("=")[1]) : -1 !== e.indexOf("sort") ? (this.state.sortBy = e) : -1 !== e.indexOf("q=") || console.error("Unknown URL param: ", e);
                        }),
                        (this.state.pageNum = this.state.pageNum || 0),
                        (this.state.activeFilterCat = 0),
                        this.initAjax(),
                        this.closeFilters(),
                        (window.onpopstate = function (e) {
                            window.location.href = window.location.href;
                        }),
                        this.setUserId(),
                        this.setSessionId(),
                        this.newResultsPageLoad(),
                        window.checkProductWishlist(),
                        window.innerWidth < 1024 ? this.addMobileToolbarScroll(427) : this.addMobileToolbarScroll(655);
                },
                getFiltersFromQueryString: (e) => (decodeURI(e), e.split("&").filter((e) => -1 !== e.indexOf("filter."))),
                captureTemplateNodes() {
                    const e = document.querySelector(l.filtersCategoryToggleTemplate);
                    e && (this.templateButton = e.cloneNode(!0));
                    const t = document.querySelector(l.filtersCategoryContentTemplate);
                    t && (this.templateContent = t.cloneNode(!0));
                },
                initElements() {
                    (this.elements = {}),
                        (this.elements.resultsContainer = document.querySelector(l.resultsContainer) || null),
                        (this.elements.filters = document.querySelector(l.filters) || null),
                        (this.elements.filtersCategoryToggles = document.querySelectorAll(l.filtersCategoryToggle)),
                        (this.elements.filtersCategoryContents = document.querySelectorAll(l.filtersCategoryContent)),
                        (this.elements.filtersCategoryColumn = document.querySelector(l.filtersCategoryColumn)),
                        (this.elements.filtersContentColumn = document.querySelector(l.filtersContentColumn)),
                        (this.elements.activeFiltersList = document.querySelector(l.activeFiltersList)),
                        (this.elements.filtersHeader = document.querySelector(l.filtersHeader)),
                        (this.elements.filtersLinks = document.querySelectorAll(l.filtersLink)),
                        (this.elements.filtersOpen = document.querySelector(l.filtersOpen) || null),
                        (this.elements.sizesMenu = document.querySelector(l.sizesMenu) || null),
                        (this.elements.filtersOverlay = document.querySelector(l.filtersOverlay) || null),
                        (this.elements.filtersClose = document.querySelectorAll(l.filtersClose) || null),
                        (this.elements.paginationLess = document.querySelector(l.collectionPaginationLess)),
                        (this.elements.paginationMore = document.querySelector(l.collectionPaginationMore)),
                        (this.elements.sortByMenu = document.querySelector(l.sortBy)),
                        (this.elements.siteContainer = document.querySelector(l.siteContainer)),
                        (this.elements.utils = document.querySelector(l.collectionUtils));
                },
                removeClearAll() {
                    const e = document.querySelector(l.clearAllLink);
                    e && e.remove();
                },
                renderClearAll() {
                    if (document.querySelector(l.clearAllLink)) return;
                    const e = document.createElement("a");
                    e.innerText = "Clear All";
                    const t = -1 === window.location.href.indexOf("/search") ? window.location.href.split("?")[0] : window.location.href.split("&")[0];
                    e.setAttribute("href", t),
                        e.classList.add("clear-all-link"),
                        e.addEventListener(
                            "click",
                            function (e) {
                                e.preventDefault(), (this.state.activeFilters = []), (this.state.activeFilterCat = 0), (this.state.pageNum = 0), this.pushState(t, { prevUrl: window.location.href }), this.newResultsPageLoad();
                            }.bind(this)
                        ),
                        this.elements.filtersHeader.insertBefore(e, this.elements.filtersHeader.children[1]);
                },
                renderFilterElements(e, t, i, n) {
                    let s = b(t, e);
                    this.state.activeFilterCat !== n && this.state.activeFilterCat !== e.field && (s = s.replace('aria-expanded="true"', "")),
                        (s = s.slice(0, s.indexOf('">') + 1) + ` data-filter-name="${e.field}"` + s.slice(s.indexOf('">') + 1, s.length));
                    const r = b(i, e),
                        l = [],
                        a = document.createElement("ul");
                    e.values.forEach((t) => {
                        const i = document.createElement("span");
                        i.innerText = `${t.label} (${t.count})`;
                        const n = document.createElement("div");
                        n.classList.add("filter-name");
                        const s = document.createElement("a"),
                            r = `filter.${e.field}=${t.value}`,
                            c = encodeURI(r),
                            d = `${-1 === window.location.href.indexOf("/search") ? window.location.href.split("?")[0] : window.location.href.split("&")[0]}?${c}`;
                        s.setAttribute("href", d), s.setAttribute("id", r), s.setAttribute("rel", "nofollow"), 0 === t.count && s.setAttribute("disabled", "disabled");
                        const h = document.createElement("li");
                        if ((n.appendChild(i), s.appendChild(n), h.appendChild(s), t.active)) {
                            n.classList.add("selected"), s.classList.add(o);
                            const i = document.createElement("a");
                            i.setAttribute("href", d),
                                i.setAttribute("id", r),
                                i.classList.add(o),
                                (i.innerText = `${e.label}: ${t.label}`),
                                i.setAttribute("aria-label", `Remove filter: ${e.label} ${t.label} `),
                                l.push(i),
                                e.field === v && (s.setAttribute(u, ""), i.setAttribute(u, ""));
                        }
                        a.appendChild(h);
                    }),
                        e.field === v && this.renderSizes(e);
                    const c = new DOMParser().parseFromString(r, "text/html").body.firstChild;
                    return this.state.activeFilterCat !== n && this.state.activeFilterCat !== e.field && c.classList.remove(o), c.appendChild(a), { filterToggle: s, filterContent: c, filterClearLinks: l };
                },
                renderSizes(e) {
                    const t = document.createElement("option");
                    t.setAttribute("value", ""), (t.innerText = this.elements.sizesMenu.getAttribute("placeholder"));
                    const i = this.elements.sizesMenu.cloneNode();
                    i.appendChild(t);
                    let n = 0;
                    e.values.forEach((t) => {
                        const s = `filter.${e.field}=${t.value}`,
                            r = document.createElement("option");
                        r.setAttribute("value", t.value), (r.innerText = t.label), (r.id = s), t.active && (r.setAttribute("selected", "selected"), (n += 1)), i.appendChild(r);
                    }),
                        0 === n && t.setAttribute("selected", "selected"),
                        i.addEventListener("change", this.handleSizeChange.bind(this)),
                        this.elements.sizesMenu.replaceWith(i);
                },
                handleSizeChange(e) {
                    const t = e.target.selectedIndex,
                        i = e.target.children[t],
                        n = this.state.activeFilters.filter((e) => -1 === e.indexOf("size"));
                    (this.state.activeFilters = [...n, i.id]), (this.state.pageNum = 0), (this.state.sortBy = null), (this.state.activeFilter = 0);
                    const s = this.createUrl();
                    this.pushState(s, { prevUrl: window.location.href }), window.innerWidth > 960 && window.scrollTo(0, 0), this.newResultsPageLoad();
                },
                handleSuggestClick(e) {
                    theme.searchQuery = e.target.getAttribute(l.suggestLinkAttr);
                    const t = document.querySelector(l.searchInput);
                    t && (t.value = theme.searchQuery), this.newResultsPageLoad();
                    const i = window.location.href.split("=")[0] + "=" + theme.searchQuery;
                    this.pushState(i, { prevUrl: window.location.href }), this.renderQueryInfo();
                },
                createUrl(e = !1) {
                    const t = -1 === window.location.href.indexOf("/search") ? window.location.href.split("?")[0] : window.location.href.split("&")[0],
                        i = this.state.activeFilters.join("&");
                    return `${t}${-1 === t.indexOf("?") ? "?" : "&"}${i}${this.state.sortBy ? "&" + this.state.sortBy : ""}${this.state.pageNum > 0 && e ? "&" + this.state.pageNum : ""}`.replace("?&", "?");
                },
                renderQueryInfo(e) {
                    const t = document.querySelector(`[${l.queryInfoAttr}]`);
                    if (t) {
                        t.innerHTML = "";
                
                        if (e.corrected) {
                            const i = t.getAttribute(l.queryInfoAttr)
                                        .replace("X", e.corrected)
                                        .replace("Y", e.original);
                            t.innerHTML = i;
                        } else if (e.didYouMean) {
                            const i = t.getAttribute(l.didYouMeanAttr)
                                        .replace("X", `<a class='highlighted' ${l.suggestLinkAttr}="${e.didYouMean.query}">${e.didYouMean.query}</a>`);
                            t.innerHTML = i;
                            t.children[0].addEventListener("click", this.handleSuggestClick.bind(this));
                        } else if ("none" == e) {
                            const i = t.getAttribute(l.noResultsAttr)
                                        .replace("X", theme.searchQuery);
                            t.innerHTML = i;
                        }
                
                        t.classList.remove("is-hidden");
                    }
                },
                renderProductFilters(e) {
                    const t = this.templateButton.outerHTML.toString(),
                        i = this.templateContent.cloneNode(!0);
                    i.querySelector("ul").remove();
                    const n = i.outerHTML.toString();
                    this.elements.filtersCategoryToggles.forEach((e) => e.remove()), this.elements.filtersCategoryContents.forEach((e) => e.remove());
                    const s = [],
                        r = [],
                        l = [];
                    e.forEach((e, i) => {
                        const { filterToggle: o, filterContent: a, filterClearLinks: c } = this.renderFilterElements(e, t, n, i);
                        s.push(o), r.push(a), c.forEach((e) => l.push(e));
                    });
                    const o = document.createElement("div");
                    r.forEach((e) => o.appendChild(e));
                    const a = document.createElement("div");
                    l.forEach((e) => a.appendChild(e)),
                        (this.elements.filtersCategoryColumn.innerHTML = s.join("")),
                        (this.elements.filtersContentColumn.innerHTML = o.innerHTML),
                        0 !== l.length
                            ? ((this.elements.activeFiltersList.innerHTML = a.innerHTML), this.elements.activeFiltersList.classList.remove(m), this.elements.filters.classList.add(h), this.renderClearAll())
                            : ((this.elements.activeFiltersList.innerHTML = ""), this.elements.activeFiltersList.classList.add(m), this.elements.filters.classList.remove(h), this.removeClearAll());
                },
                handleSortChange(e) {
                    e.preventDefault();
                    const t = e.target.selectedIndex,
                        i = e.target.children[t];
                    (this.state.sortBy = i.value), (this.state.pageNum = 0);
                    const n = this.createUrl();
                    this.pushState(n, { prevUrl: window.location.href }), window.innerWidth > 960 && window.scrollTo(0, 0), this.newResultsPageLoad();
                },
                renderSorting(e) {
                    this.elements.sortByMenu.innerHTML = "";
                    const t = document.createElement("select");
                    (t.id = this.elements.sortByMenu.id), (t.classList = this.elements.sortByMenu.classList), (t.ariaLabel = this.elements.sortByMenu.ariaLabel);
                    const i = document.createElement("option");
                    i.setAttribute("value", ""),
                        (i.innerText = "Sort By"),
                        t.appendChild(i),
                        e.forEach((e) => {
                            const i = document.createElement("option"),
                                n = `sort.${e.field}=${e.direction}`;
                            (i.value = n), this.state.sortBy === n && i.setAttribute("selected", ""), (i.innerText = e.label), t.appendChild(i);
                        }),
                        this.elements.sortByMenu.replaceWith(t),
                        t.addEventListener("change", this.handleSortChange.bind(this));
                },
                async newResultsPageLoad() {
                    this.setLoading(), this.setPageLoadId();
                    const e = await this.getSearchspringSearchApiResults(),
                        t = e.results ? await e.results.map(n.f) : [],
                        i = e.results ? await e.results.map(n.c) : [],
                        s = await Promise.all(i);
                    if (((this.gaItems = s), 0 === t.length && e.merchandising && e.merchandising.redirect.length > 0)) {
                        const t = window.location.href.split("/")[0] + e.merchandising.redirect;
                        window.location.href = t;
                    } else if (0 === t.length && "search" === r) {
                        e.didYouMean ? this.renderQueryInfo(e) : this.renderQueryInfo("none");
                        const t = document.querySelector(l.collectionUtils);
                        (t.hidden = "hidden"),
                            "true" === t.dataset.nostoEnabled
                                ? (t.innerHTML =
                                      '<h3 class="title has-text-centered is-spaced is-size-4 has-margin-bottom has-text-weight-normal has-font-tertiary">Bestsellers you might like</h3> <div class="nosto_element" id="search_no_results"></div>')
                                : ((t.innerHTML = ""), document.querySelector(l.searchspringRecsContainer).removeAttribute("hidden"));
                    }
                    Promise.all(t).then((t) => {
                        const i = t.map((e) => e.json());
                        Promise.all(i).then((t) => {
                            const i = t.map((e) => e[this.productItemSection]).join("");
                            this.elements.resultsContainer.innerHTML = i;

                            const wrappers = this.elements.resultsContainer.querySelectorAll('[id="shopify-section-product-list-item"]');

                            wrappers.forEach((wrapper) => {
                                const productEl = wrapper.querySelector('.product-list-item');
                                if (!productEl) return;

                                const sku = productEl.getAttribute('data-product-sku');
                                if (!sku) return;

                                wrapper.id = `product-list-item-${sku}`;
                            });

                            const s = e.merchandising.content.inline;
                            s &&
                                s.length > 0 &&
                                s.forEach((e) => {
                                    const t = document.createElement("div");
                                    t.classList.add("product-list-item");
                                    const i = e.value.replace("src=", 'class="lazyload" data-src=');
                                    (t.innerHTML = i), this.elements.resultsContainer.insertBefore(t, this.elements.resultsContainer.children[e.config.position.index]);
                                }),
                                this.addItemClickListeners(),
                                this.setLoaded(),
                                Object(n.i)(this.gaItems, "view_item_list");
                        });
                    }),
                        e.facets.length > 0 && this.renderProductFilters(e.facets),
                        e.sorting.options && e.sorting.options.length > 0 && this.renderSorting(e.sorting.options),
                        e.query && this.renderQueryInfo(e.query),
                        this.renderPagination(e),
                        this.initElements(),
                        this.initAjax();
                },
                addItemClickListeners() {
                    async function e(e) {
                        if (!0 === this.clickLogged) return;
                        e.preventDefault();
                        const t = e.target.classList.contains(l.productItem.replace(".", "")) ? e.target : e.target.closest(l.productItem);
                        if (this.gaItems) {
                            const e = this.gaItems.find((e) => String(e.item_id) === t.getAttribute(l.skuAttr));
                            e && Object(n.i)([e], "select_item");
                        }
                        (this.clickLogged = !0), e.target.click();
                    }
                    this.elements.resultsContainer.querySelectorAll(l.productItem).forEach((t) => {
                        t.addEventListener("click", e.bind(this));
                    });
                },
                onClickPagination(e) {
                    const t = window.location.href.replace("&page=" + this.state.pageNum, "").replace("?page=" + this.state.pageNum, ""),
                        i = e.target.getAttribute("data-page"),
                        n = -1 === t.indexOf("?") ? `${t}?page=${i}` : `${t}&page=${i}`;
                    (this.state.pageNum = i), this.newResultsPageLoad(), this.pushState(n, { prevUrl: window.location.href });
                    const s = document.querySelector("h1");
                    s && s.scrollIntoView();
                },
                renderPagination(e) {
                    const currentUrl = new URL(window.location.href);

                    // --- Clean up params ---
                    const paramsToDelete = [];
                    currentUrl.searchParams.forEach((_, key) => {
                        if (key === 'page' || key.startsWith('utm_')) {
                            paramsToDelete.push(key);
                        }
                    });
                    paramsToDelete.forEach(key => currentUrl.searchParams.delete(key));

                    // Base URL without page/utm params
                    const baseUrl = currentUrl.origin + currentUrl.pathname + (currentUrl.search ? '?' + currentUrl.searchParams.toString() : '');

                    if (((this.elements.paginationLess.innerHTML = ""), (this.elements.paginationMore.innerHTML = ""), 0 !== e.pagination.nextPage)) {
                        const nextUrl = baseUrl + (baseUrl.includes('?') ? '&' : '?') + 'page=' + e.pagination.nextPage;
                        
                        const t = document.createElement("a");
                            t.classList.add("c-btn", "main", "primary"),
                            t.innerText = "Next",
                            t.setAttribute("data-page", e.pagination.nextPage),
                            t.setAttribute("href", nextUrl),
                            t.setAttribute("rel", "next"),
                            this.elements.paginationMore.appendChild(t);
                    }
                    if (0 !== e.pagination.previousPage) {

                        let prevUrl = baseUrl;
                        if (e.pagination.previousPage > 1) {
                            prevUrl = baseUrl + (baseUrl.includes('?') ? '&' : '?') + 'page=' + e.pagination.previousPage;
                        }

                        const t = document.createElement("a");
                        t.classList.add("c-btn", "main", "primary"),
                            t.innerText = "Previous",
                            t.setAttribute("data-page", e.pagination.previousPage),
                            t.setAttribute("href", prevUrl),                          
                            t.setAttribute("rel", "prev"),
                            this.elements.paginationLess.appendChild(t);
                    }
                },
                addBreakpointEventListeners() {
                    window.addEventListener("breakpoint-down:lg", this.filterCategoryVisiblity.bind(this)), window.addEventListener("breakpoint-up:lg", this.filterCategoryVisiblity.bind(this));
                },
                initNoAjax() {
                    this.initFilters(), this.initSort(), this.backBtn && this.backBtn.addEventListener("click", this.onClickEmptyBack.bind(this));
                },
                initAjax(e = !1) {
                    this.initElements(), this.initFilters(), this.initAjaxLinks(), e && theme.quickCart && new theme.quickCart.constructor(), this.backBtn && this.backBtn.addEventListener("click", this.onClickEmptyBack.bind(this));
                },
                setState(e, t) {
                    return void 0 !== e && this.state.hasOwnProperty(e) && void 0 !== t && (this.state[e] = t), this.state;
                },
                initSort() {
                    this.elements.collectionSort && this.elements.collectionSort.addEventListener("change", this.onSort.bind(this));
                },
                onSort(e) {
                    let t = e.currentTarget,
                        i = new URLSearchParams(location.search),
                        n = t.options[t.selectedIndex];
                    i.set("sort_by", n.value), (window.location.search = i);
                },
                initFilters() {
                    this.elements.filters &&
                        (this.elements.filtersOpen && this.elements.filtersOpen.addEventListener("click", this.onClickFiltersOpen.bind(this)),
                        this.elements.filtersCategoryToggles.length &&
                            this.elements.filtersCategoryToggles.forEach((e) => {
                                e.addEventListener("click", this.onClickFiltersCategoryToggle.bind(this));
                            }),
                        this.elements.filtersClose.length > 0 && this.elements.filtersClose.forEach((e) => e.addEventListener("click", this.onClickFiltersClose.bind(this))),
                        this.elements.filtersApply && this.elements.filtersApply.addEventListener("click", this.onClickFiltersApply.bind(this)));
                },
                initFiltersOpen() {
                    this.elements.filtersOpen && this.elements.filters && this.elements.filtersOpen.addEventListener("click", this.onClickFiltersOpen.bind(this));
                },
                initFiltersAccordions() {
                    this.elements.filters &&
                        this.elements.filtersCategoryToggles.length &&
                        this.elements.filtersCategoryToggles.forEach((e) => {
                            e.addEventListener("click", this.onClickFiltersCategoryToggle.bind(this));
                        });
                },
                onClickFiltersOpen(e) {
                    if ((e.preventDefault(), !this.elements.filters.classList.contains(d))) return window.innerWidth < 960 && window.scrollTo(0, 0), Object(n.g)(), this.openFilters();
                },
                onClickFiltersCategoryToggle(e) {
                    e.preventDefault();
                    const t = e.target.closest("button");
                    if (!t || !t.getAttribute("aria-controls")) throw new Error("No button or controlled category content specified.");
                    const i = document.getElementById(t.getAttribute("aria-controls"));
                    i.classList.contains(o) ||
                        (this.elements.filtersCategoryContents.forEach((e) => e.classList.remove(o)),
                        i.classList.add(o),
                        this.elements.filtersCategoryToggles.forEach((e) => e.setAttribute("aria-expanded", !1)),
                        t.setAttribute("aria-expanded", !0),
                        (this.state.activeFilterCat = t.dataset.filterName));
                },
                onClickFiltersApply(e) {
                    return e.preventDefault(), this.closeFilters();
                },
                onClickFiltersClose(e) {
                    if ((e.preventDefault(), this.elements.filters.classList.contains(d))) return Object(n.k)(), this.closeFilters();
                },
                openFilters() {
                    (this.lastButtonClicked = "filter"), this.elements.filters.classList.add(d), this.elements.filtersOverlay.classList.add(d), this.elements.utils.classList.add(o);
                    const e = document.querySelector(l.gorgiasChatContainer);
                    e && e.setAttribute("style", "display:none"), Object(n.g)();
                },
                closeFilters() {
                    (this.lastButtonClicked = "filter"), this.elements.filters.classList.remove(d), this.elements.filtersOverlay.classList.remove(d), this.elements.utils.classList.remove(o);
                    const e = document.querySelector(l.gorgiasChatContainer);
                    e && e.removeAttribute("style"), Object(n.k)();
                },
                pushState(e, t = {}) {
                    e && "" != e && window.history.pushState(t, null, e);
                },
                initAjaxLinks() {
                    this.elements.filtersLinks &&
                        this.elements.filtersLinks.length &&
                        this.elements.filtersLinks.forEach((e) => {
                            e.addEventListener("click", this.onClickAjaxLink.bind(this));
                        });
                },
                async onClickAjaxLink(e) {
                    e.preventDefault();
                    const t = e.currentTarget,
                        i = t.hasAttribute("id") ? t.getAttribute("id") : null,
                        n = t.classList.contains(o);
                    this.setState("lastClicked", t),
                        (this.state.pageNum = 0),
                        n ? ((this.state.activeFilters = this.state.activeFilters.filter((e) => e !== i)), this.newResultsPageLoad()) : (this.state.activeFilters.push(i), this.newResultsPageLoad());
                    const s = this.createUrl();
                    this.pushState(s, { prevUrl: window.location.href });
                },
                initAjaxPagination() {
                    this.elements.collectionPagination &&
                        [...this.elements.collectionPagination.querySelectorAll("a")].forEach((e) => {
                            e.addEventListener("click", this.onClickAjaxPagination.bind(this));
                        }),
                        theme.enableInfiniteResults &&
                            (this.elements.collectionPaginationLessBtn && this.elements.collectionPaginationLessBtn.addEventListener("click", this.onClickAjaxPaginationDirection.bind(this)),
                            this.elements.collectionPaginationMoreBtn && this.elements.collectionPaginationMoreBtn.addEventListener("click", this.onClickAjaxPaginationDirection.bind(this)));
                },
                async onClickAjaxPagination(e) {
                    e.preventDefault(), (this.lastButtonClicked = "pagination");
                    const t = e.currentTarget,
                        i = t.hasAttribute("href") ? t.getAttribute("href") : null;
                    await this.getCollectionResults(i);
                },
                async onClickAjaxPaginationDirection(e) {
                    e.preventDefault(), (this.lastButtonClicked = "pagination");
                    const t = void 0 !== e.target.dataset.collectionPaginationMoreBtn || void 0 !== e.target.dataset.searchPaginationMoreBtn ? "next" : "previous",
                        i = e.target,
                        n = (i.hasAttribute("href") ? i.getAttribute("href") : null).split("?"),
                        s = "?" + n[n.length - 1];
                    await this.getCollectionResultsPage(s, t);
                },
                setUserId() {
                    const e = Object(n.b)("ssUserId");
                    if (e) this.userId = e;
                    else {
                        const e = s.v4();
                        (this.userId = e), Object(n.j)("ssUserId", e, 365);
                    }
                },
                setSessionId() {
                    const e = Object(n.b)("ssSessionIdNamespace");
                    if (e) this.sessionId = e;
                    else {
                        const e = s.v4();
                        (this.sessionId = e), Object(n.j)("ssSessionIdNamespace", e);
                    }
                },
                setPageLoadId() {
                    const e = s.v4();
                    this.pageLoadId = e;
                },
                async getSearchspringSearchApiResults() {
                    const e = this.state.activeFilters.length > 0 ? "&" + this.state.activeFilters.join("&") : "",
                        t = theme.collectionName ? "&bgfilter.collection_handle=" + theme.collectionName : "&q=" + theme.searchQuery,
                        i = -1 === window.location.href.indexOf("/search") ? window.location.href.split("?")[0] : window.location.href.split("&")[0],
                        s = `&resultsFormat=json&userId=${this.userId}&sessionId=${this.sessionId}&pageLoadId=${this.pageLoadId}&domain=${i}&bgfilter.ss_is_published=1${t}${e}&resultsPerPage=${theme.itemsPerPage}&page=${
                            this.state.pageNum
                        }&redirectResponse=minimal${this.state.sortBy ? "&" + this.state.sortBy : ""}`,
                        r = `${p}${g}${s}`;
                    return await Object(n.d)(r);
                },
                setLoading() {
                    this.disableUI();
                    const e = document.createElement("div");
                    e.classList.add("loading-spinner"), this.elements.resultsContainer.appendChild(e), this.elements.resultsContainer.classList.add(c), window.innerWidth < 960 && window.scrollTo(0, 0);
                },
                setLoaded() {
                    this.enableUI(), this.elements.resultsContainer.classList.remove(c), theme.wishlistModal();
                },
                enableUI(e = []) {
                    this.elements.filtersOpen && !e.includes(this.elements.filtersOpen) && this.elements.filtersOpen.removeAttribute("disabled"),
                        this.elements.filtersCategoryToggles.forEach((e) => e.removeAttribute("disabled")),
                        this.elements.filtersLinks.forEach((e) => e.classList.remove(a)),
                        this.elements.filtersClear &&
                            !e.includes(this.elements.filtersClear) &&
                            this.elements.filtersClear.forEach((e) => {
                                e.classList.remove(a);
                            }),
                        this.elements.filtersApply && !e.includes(this.elements.filtersApply) && this.elements.filtersApply.removeAttribute("disabled"),
                        this.elements.collectionSort && !e.includes(this.elements.collectionSort) && this.elements.collectionSort.removeAttribute("disabled", !0),
                        this.elements.collectionProducts && !e.includes(this.elements.collectionProducts) && this.elements.collectionProducts.classList.remove(c),
                        this.elements.collectionPagination && !e.includes(this.elements.collectionPagination) && this.elements.collectionPagination.classList.remove(c),
                        theme.enableInfiniteResults &&
                            (this.elements.collectionPaginationMoreBtn && !e.includes(this.elements.collectionPaginationMoreBtn) && this.elements.collectionPaginationMoreBtn.classList.remove(c),
                            this.elements.collectionPaginationLessBtn && !e.includes(this.elements.collectionPaginationLessBtn) && this.elements.collectionPaginationLessBtn.classList.remove(c));
                },
                disableUI() {
                    this.elements.filtersOpen && this.elements.filtersOpen.setAttribute("disabled", !0),
                        this.elements.filtersCategoryToggles.forEach((e) => e.setAttribute("disabled", !0)),
                        this.elements.filtersLinks.forEach((e) => e.classList.add(a)),
                        this.elements.filtersClear &&
                            this.elements.filtersClear.forEach((e) => {
                                e.classList.add(a);
                            }),
                        this.elements.filtersApply && this.elements.filtersApply.setAttribute("disabled", !0),
                        this.elements.collectionSort && this.elements.collectionSort.setAttribute("disabled", !0),
                        this.elements.collectionProducts && this.elements.collectionProducts.classList.add(c),
                        this.elements.collectionPagination && this.elements.collectionPagination.classList.add(c),
                        theme.enableInfiniteResults &&
                            (this.elements.collectionPaginationMoreBtn && this.elements.collectionPaginationMoreBtn.classList.add(c), this.elements.collectionPaginationLessBtn && this.elements.collectionPaginationLessBtn.classList.add(c));
                },
                addMobileToolbarScroll(e) {
                    const t = document.querySelector(l.collectionUtils);
                    let i = !1,
                        n = 0;
                    document.querySelector(l.siteContainer).addEventListener("scroll", function (e) {
                        (i = !0), (n = e.target.scrollTop);
                    }),
                        setInterval(() => {
                            i && ((i = !1), n > e ? t.classList.contains(f) || t.classList.add(f) : t.classList.contains(f) && t.classList.remove(f));
                        }, 300);
                },
                onClickEmptyBack(e) {
                    e.preventDefault(), (window.location.href = document.referrer);
                },
                onError(e) {
                    console.warn("Collection:", e), this.setState("isFetching", !1), this.enableUI();
                },
            },
            w = document.getElementById("section-" + r);
        C.onFiltersInit(w), "collection" === r ? theme.sections.register("collection", C) : theme.sections.register("search", C);
    },
]);
